import React, { useState, useEffect } from "react";
import Context from "../../Context";
import { Header } from "../../components/modules";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/base";
import { IoReceiptOutline } from "react-icons/io5";
import { BiLogIn } from "react-icons/bi";
import { FiSearch, FiRefreshCw } from "react-icons/fi";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import constant from "../../constants";
import { OrderStatusBadge } from "../../components/modules";

export const OrdersLine = () => {
  const { callApi, configs } = Context();
  const [orders, setOrders] = useState(false);
  const [loading, setLoading] = useState(true);
  const [roundDate, setRoundDate] = useState(configs.roundDate);
  const [pages, setPages] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const [searchValue, setSearchValue] = useState("");
  const [searchType, setSearchType] = useState("shortId");
  const [status, setStatus] = useState("");

  useEffect(() => {
    getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roundDate, status]);

  const getOrders = async () => {
    setLoading(true);
    setCurrentPage(1);

    const apiQueries = [["isLineOrder", true]];
    if (status) {
      apiQueries.push(["status", status]);
    }
    if (searchValue) {
      apiQueries.push([searchType, searchValue]);
    }

    const result = await callApi(
      "orders-getAll",
      {
        roundDate: roundDate,
        queries: apiQueries,
        limit: 500,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true }
    );

    const ordersList = Array.isArray(result) ? result : [];

    const pages = {};
    let index = 1;
    const chunkSize = 50;

    for (let i = 0; i < ordersList.length; i += chunkSize) {
      const chunk = ordersList.slice(i, i + chunkSize);
      pages[index] = chunk;
      index++;
    }

    setPages(pages);
    setOrders(ordersList);
    setLoading(false);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mx-auto pb-10 min-w-0">
      <Header
        header="LINE Orders"
        subHeader={`คำสั่งซื้อสลาก LINE`}
        icon={<IoReceiptOutline className="text-blue" />}
      />

      <div className="mt-4 bg-white rounded-md shadow-md border border-gray-200 p-4 flex flex-col gap-4">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            getOrders();
          }}
          className="flex flex-wrap items-end gap-3 shrink-0"
        >
          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold text-gray-700">งวดสลาก</label>
            <select
              className="h-10 min-w-[140px] px-3 bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all cursor-pointer"
              onChange={(e) => setRoundDate(e.target.value)}
              value={roundDate || ""}
            >
              {configs.roundDates.map((date, index) => {
                return (
                  <option key={index} value={date}>
                    {date}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold text-gray-700">สถานะ</label>
            <select
              disabled={loading}
              className="h-10 min-w-[140px] px-3 bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all cursor-pointer disabled:text-gray-400"
              value={status || ""}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value={""}>ทั้งหมด</option>
              <option value={constant.statuses.APPROVE}>
                {constant.statusesTranslate.approved}
              </option>
              <option value={constant.statuses.PAID}>
                {constant.statusesTranslate.paid}
              </option>
              <option value={constant.statuses.PENDING}>
                {constant.statusesTranslate.pending}
              </option>
              <option value={constant.statuses.CANCEL}>
                {constant.statusesTranslate.canceled}
              </option>
            </select>
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold text-gray-700">ค้นหาตาม</label>
            <select
              disabled={loading}
              className="h-10 min-w-[140px] px-3 bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all cursor-pointer disabled:text-gray-400"
              value={searchType}
              onChange={(e) => setSearchType(e.target.value)}
            >
              <option value={`shortId`}>รหัสคำสั่งซื้อ</option>
              <option value={`phone`}>เบอร์โทรศัพท์</option>
              <option value={`userId`}>รหัสผู้ใช้</option>
              <option value={`firstName`}>ชื่อ</option>
              <option value={`lastName`}>นามสกุล</option>
              <option value={`lineTitle`}>ชื่อไลน์</option>
            </select>
          </div>

          <div className="flex flex-col gap-1 flex-1 min-w-[200px] max-w-[420px]">
            <label className="text-xs font-bold text-gray-700">คำค้นหา</label>
            <input
              className="h-10 w-full px-3 bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all placeholder:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="พิมพ์เพื่อค้นหา..."
            />
          </div>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              disabled={loading}
              className="h-10 px-4 flex items-center justify-center gap-1.5 bg-blue hover:bg-blue/90 text-white text-sm font-bold rounded-md shadow-xs transition-all duration-150 disabled:opacity-50 cursor-pointer"
            >
              <FiSearch className="w-4 h-4" />
              <span>ค้นหา</span>
            </button>
            <button
              type="button"
              disabled={loading}
              className="h-10 px-4 flex items-center justify-center gap-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-bold rounded-md border border-gray-300 shadow-xs transition-all cursor-pointer disabled:opacity-50"
              onClick={async () => {
                setSearchValue("");
                setStatus("");
                getOrders();
              }}
            >
              <FiRefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
              <span>รีเซ็ต</span>
            </button>
          </div>
        </form>
      </div>

      <div className="mt-4 bg-white rounded-md shadow-md border border-gray-200 overflow-hidden">
        <div className="flex items-center p-4 border-b border-gray-200 bg-gray-50/60 justify-between flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-bold text-gray-800">
              คำสั่งซื้อสลาก LINE{" "}
              {status ? ` (${constant.statusesTranslate[status] || status})` : ""}
            </h2>
            <span className="px-2.5 py-0.5 text-xs font-bold bg-gray-200 text-gray-700 rounded-md">
              {orders ? orders.length : 0} รายการ
            </span>
          </div>

          <div>
            <Pagination className={``}>
              <PaginationContent>
                <PaginationItem className="hover:bg-none">
                  <PaginationPrevious
                    className={`${
                      currentPage > 1
                        ? "cursor-pointer"
                        : "cursor-not-allowed hover:bg-transparent opacity-45"
                    } font-semibold`}
                    onClick={() =>
                      setCurrentPage((prevState) =>
                        prevState > 1 ? prevState - 1 : 1
                      )
                    }
                  />
                </PaginationItem>
                {Object.keys(pages).map((p) => {
                  return (
                    <PaginationItem key={p}>
                      <PaginationLink
                        onClick={() => setCurrentPage(Number(p))}
                        isActive={currentPage === Number(p)}
                        className={`cursor-pointer font-semibold`}
                      >
                        {p}
                      </PaginationLink>
                    </PaginationItem>
                  );
                })}

                <PaginationItem>
                  <PaginationNext
                    className={`${
                      currentPage < Object.keys(pages).length
                        ? "cursor-pointer"
                        : "cursor-not-allowed hover:bg-transparent opacity-45"
                    } font-semibold`}
                    onClick={() =>
                      setCurrentPage((prevState) =>
                        prevState < Object.keys(pages).length
                          ? prevState + 1
                          : prevState
                      )
                    }
                  />
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <Table>
          <TableHeader className={`bg-[#f2f3f5]`}>
            <TableRow>
              <TableHead className={`text-center whitespace-nowrap`}>ลำดับ</TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>
                <p className="">เวลาสร้างคำสั่งซื้อ</p>
                <p className="text-failed text-xs ">(หมดอายุ)</p>
              </TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>รหัสคำสั่งซื้อ</TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>รหัสผู้ใช้ </TableHead>
              <TableHead className={`whitespace-nowrap`}>เบอร์โทรศัพท์</TableHead>
              <TableHead className={`whitespace-nowrap`}>ชื่อ-นามสกุล</TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>จำนวน</TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>ราคา</TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>ช่องทางชำระ</TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>สลิป</TableHead>
              <TableHead className={`text-center whitespace-nowrap`}>สถานะ</TableHead>
              <TableHead className={`whitespace-nowrap`}></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableRow className={`h-[80px]`}>
                <TableCell colSpan="13">
                  <div className="w-full h-[500px] flex justify-center items-center">
                    <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                  </div>
                </TableCell>
              </TableRow>
            ) : orders.length === 0 ? (
              <TableRow className={`h-[80px]`}>
                <TableCell
                  colSpan="13"
                  className="h-96 font-semibold text-center text-gray-400"
                >
                  ไม่พบข้อมูล
                </TableCell>
              </TableRow>
            ) : (
              <>
                {(pages[currentPage] || []).map((order, index) => (
                  <OrderCell
                    order={order}
                    key={order.id}
                    index={(currentPage - 1) * 50 + index}
                    getOrders={getOrders}
                  />
                ))}
              </>
            )}
          </TableBody>
        </Table>
        </div>
      </div>
    </div>
  );
};

const OrderCell = ({ order, index }) => {
  const { callApi } = Context();
  const [loading, setLoading] = useState(false);
  return (
    <TableRow
      className={`h-[80px] cursor-pointer hover:bg-gray-50`}
      onClick={() => {
        if (window.getSelection()?.toString()) return;
        window.open(`/orders/${order.id}`, "_blank");
      }}
    >
      <TableCell className={`text-center font-semibold`}>{index + 1}</TableCell>
      <TableCell className={``}>
        <div className="flex gap-2 items-center justify-center font-semibold ">
          {new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })}{" "}
          น.{" "}
        </div>
        <div className="text-failed text-center text-xs font-semibold ">
          (
          {new Date(order.expireAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })}{" "}
          น.){" "}
        </div>{" "}
      </TableCell>
      <TableCell className={`text-center font-semibold font-mono tabular-nums`}>
        {order.shortId}
      </TableCell>
      <TableCell className="font-semibold text-center ">
        <p className="">{order.userId}</p>
      </TableCell>
      <TableCell className="font-semibold">{order.phone}</TableCell>
      <TableCell className="font-semibold">
        {order.firstName + " " + order.lastName}
      </TableCell>
      <TableCell className="font-semibold text-center font-mono tabular-nums">
        {order.size}
      </TableCell>
      <TableCell className="font-semibold text-center font-mono tabular-nums">
        {order.paidCurrency === "LAK"
          ? `${order.totalPrice_lak?.toLocaleString()} กีบ`
          : `${Number(order.totalPrice || 0).toLocaleString()} ฿`}
      </TableCell>
      <TableCell className="font-semibold text-center ">
        {order.paymentChannel === "bank" ? (
          <img
            src={"/images/banktransfer.png"}
            className="mx-auto w-24 max-h-32 max-w-24"
            alt={order.paymentChannel}
          />
        ) : order.paymentChannel === "qr" ? (
          <img
            src={"/images/qr.png"}
            className="mx-auto w-24 max-h-32 max-w-24"
            alt={order.paymentChannel}
          />
        ) : (
          "-"
        )}
      </TableCell>
      <TableCell className="font-semibold text-center ">
        {(() => {
          const slipUrl = Array.isArray(order.slips)
            ? order.slips.length > 0 ? order.slips[order.slips.length - 1] : null
            : order.slips || null;
          return slipUrl ? (
            <img
              onClick={(e) => {
                e.stopPropagation();
                window.open(slipUrl, "_blank");
              }}
              src={slipUrl}
              style={{
                width: "100%",
                height: "100%",
                maxWidth: "40px",
                maxHeight: "80px",
                cursor: "pointer",
              }}
              className="mx-auto"
              alt="slip"
            />
          ) : (
            "-"
          );
        })()}
      </TableCell>
      <TableCell className="font-semibold text-center">
        <OrderStatusBadge status={order.status} size="sm" />
      </TableCell>
      <TableCell className={``}>
        <div className="flex justify-center gap-3">
          <button
            className="flex items-center  py-2 px-3 bg-blue text-white text-sm font-semibold rounded-md shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-200 disabled:cursor-not-allowed"
            onClick={async (e) => {
              e.stopPropagation();
              setLoading(true);
              let reasult = await callApi("users-addAdminToken", {
                userId: order.userId,
              });
              window.open(constant.getAdminOrderUrl(reasult.adminToken));

              setLoading(false);
            }}
          >
            {loading ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <BiLogIn />
            )}
          </button>
        </div>
      </TableCell>
    </TableRow>
  );
};
